import { PropertySetModule } from "@/services/admin/property-set/modal"
import { Button, Form, InputNumber, Select, Table } from "antd"
import { useEffect, useState } from "react"

export interface ReactionPartnersEditorProps {
  propertySet: PropertySetModule.Modal
  value?: PropertySetModule.ReactionSetEntry[]
  onChange?: (values: PropertySetModule.ReactionSetEntry[]) => void
}

export const ReactionsEditor = (props: ReactionPartnersEditorProps) => {
  const {value, propertySet, onChange} = props
  const [form] = Form.useForm()
  const [reactions, setReactions] = useState<PropertySetModule.ReactionSetEntry[]>(value || [])

  useEffect(() => {
    setReactions(value || [])
  }, [value])

  const options = propertySet.reactions?.map((item) => {
    return {
      value: item.id,
      label: item.name
    }
  })

  const columns = [
    {
      title: 'Reaction',
      dataIndex: 'id',
      render: (id) => {
        return propertySet.reactions.find(item => item.id === id)?.name || '-'
      }
    },
    {
      title: 'Approach To Equilibrium (K)',
      dataIndex: 'ate',
      key: 'ate',
    },
    {
      title: 'Actions',
      render: (_, record) => {
        return <Button size="small" danger onClick={() => {
          const newVal = reactions.filter(item => item !== record)
          setReactions(newVal)
          onChange?.(newVal)
        }}>Delete</Button>
      }
    },
  ]

  return <div>
    <div className="mt-2">
      <Table
        bordered
        rowKey={'id'}
        pagination={{ pageSize: 20, hideOnSinglePage: true }}
        size='small'
        columns={columns}
        dataSource={reactions}
      />
      <Form
        form={form}
        layout="inline"
        onFinish={(values) => {
          const newVal = [...reactions, values]
          setReactions(newVal)
          onChange?.(newVal)
          form.resetFields()
        }}
        className="mt-2 border p-1"
      >
        <Form.Item label='Reaction' name='id' rules={[{ required: true, message: 'Please selected a reaction type' }]}>
          <Select options={options} style={{width: 160}} />
        </Form.Item>
        <Form.Item label='Approach To Equilibrium (K)' name='ate' rules={[{ required: true, message: 'Please enter Stoichiometric Coefficient' }]}>
          <InputNumber type='text' style={{width: 60}} />
        </Form.Item>

        <Button type="primary" onClick={() => form.submit()}>Add</Button>
      </Form>
    </div>
  </div>
}